import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import clsx from 'clsx';

import './ChatMarkdown.scss';

interface ChatMarkdownProps {
  content: string;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const ChatMarkdown: React.FC<ChatMarkdownProps> = ({ content, className, size = 'sm' }) => {
  // If no content, render nothing
  if (!content || content.trim() === '') {
    return null;
  }

  return (
    <div className={clsx('chat-markdown', `chat-markdown--${size}`, className)}>
      <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
    </div>
  );
};

export default ChatMarkdown;
